import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { initObservability } from "./observability/coralogix";
import store from "./store";
import authClient from "./utils/authClient";
import { actions as loginActions } from "./login/loginActions";
import App from "./app";
import Dashboard from "./Dashboard";
import ToastRoot from "./ToastRoot";
import "./index.scss";
import "./favicon.ico";
initObservability();
const root = createRoot(document.getElementById("root"));
const renderApp = () => {
  root.render(
    /* @__PURE__ */ jsx(Provider, { store, children: /* @__PURE__ */ jsxs(BrowserRouter, { children: [
      /* @__PURE__ */ jsxs(Routes, { children: [
        /* @__PURE__ */ jsx(Route, { path: "/dashboard", element: /* @__PURE__ */ jsx(Dashboard, {}) }),
        /* @__PURE__ */ jsx(Route, { path: "*", element: /* @__PURE__ */ jsx(App, {}) })
      ] }),
      /* @__PURE__ */ jsx(ToastRoot, {})
    ] }) })
  );
};
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    const base = typeof import.meta !== "undefined" && import.meta.env && import.meta.env.BASE_URL || "/";
    const isDev = typeof import.meta !== "undefined" && import.meta.env && import.meta.env.DEV;
    const swPath = isDev ? `${base.replace(/\/$/, "")}/src/serviceWorker.js` : `${base.replace(/\/$/, "")}/serviceWorker.js`;
    navigator.serviceWorker.register(swPath, { type: "module", scope: base }).then((registration) => {
      console.log("SW registered: ", registration);
      return navigator.serviceWorker.ready;
    }).then(() => {
      if (!navigator.serviceWorker.controller) {
        location.reload();
      }
      return authClient.loadFromSW();
    }).catch((registrationError) => {
      console.log("SW registration failed/recovery failed: ", registrationError);
    }).finally(() => {
      renderApp();
    });
  });
} else {
  renderApp();
}
document.addEventListener("visibilitychange", () => {
  if (document.visibilityState === "visible" && navigator.serviceWorker?.controller) {
    const { login } = store.getState() || {};
    if (login?.isLoggedIn) {
      store.dispatch(loginActions.refresh());
    }
  }
});
